// @generated source--
// scripts/generate-bits/file-generators/component-routes.generator.ts

export const pipeRoutes = [
  {
    path: 'bypass-security-trust-resource-url',
    loadChildren: () =>
      import(
        './bypass-security-trust-resource-url/bypass-security-trust-resource-url-stories.routes'
      ).then(m => m.routes),
  },
  {
    path: 'compact-number',
    loadChildren: () =>
      import('./compact-number/compact-number-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'freelancer-currency',
    loadChildren: () =>
      import('./freelancer-currency/freelancer-currency-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'date-range',
    loadChildren: () =>
      import('./date-range/date-range-stories.routes').then(m => m.routes),
  },
  {
    path: 'duration',
    loadChildren: () =>
      import('./duration/duration-stories.routes').then(m => m.routes),
  },
  {
    path: 'dynamic-time',
    loadChildren: () =>
      import('./dynamic-time/dynamic-time-stories.routes').then(m => m.routes),
  },
  {
    path: 'emoji',
    loadChildren: () =>
      import('./emoji/emoji-stories.routes').then(m => m.routes),
  },
  {
    path: 'file-size',
    loadChildren: () =>
      import('./file-size/file-size-stories.routes').then(m => m.routes),
  },
  {
    path: 'is-online',
    loadChildren: () =>
      import('./is-online/is-online-stories.routes').then(m => m.routes),
  },
  {
    path: 'location',
    loadChildren: () =>
      import('./location/location-stories.routes').then(m => m.routes),
  },
  {
    path: 'pascal-case',
    loadChildren: () =>
      import('./pascal-case/pascal-case-stories.routes').then(m => m.routes),
  },
  {
    path: 'sanitise',
    loadChildren: () =>
      import('./sanitise/sanitise-stories.routes').then(m => m.routes),
  },
  {
    path: 'truncate-filename',
    loadChildren: () =>
      import('./truncate-filename/truncate-filename-stories.routes').then(
        m => m.routes,
      ),
  },
];
